import TablaYounet from '../Elementos/TablaYounet';


const Element =()=>{

    const headCellsColumn = [
        { id: 'Titulo', numeric: false, disablePadding: false, label: 'TITULO', show:true, fixed:false, width:150, num:0, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'Modulo', numeric: false, disablePadding: false, label: 'MODULO', show:true, fixed:false, width:250, num:1, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'Seccion', numeric: false, disablePadding: false, label: 'SECCION', show:true, fixed:false, width:150, num:2, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'linkTo', numeric: false, disablePadding: false, label: 'LINKTO', show:true, fixed:false, width:250, num:3, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'Icono', numeric: false, disablePadding: false, label: 'ICONO', show:true, fixed:false, width:250, num:4, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'iconSize', numeric: true, disablePadding: false, label: 'ICON SIZE', show:true, fixed:false, width:110, num:5, align:'center', fontSize:'16px', bolder:false, type:'number' },
    ];

    const variablesObject = {
        api:'/api/Modulos',
        apiMultiples:'/api/Modulos/multiple',
        isButtonAdd:true,
        isMultiline:false,
        isUpperCase:false,
        label:'Modulo',  
        nameLocalStorage:'headersModulosYounet',
        order:'asc',
        orderBy:'Seccion',
        rowsPerPage:15,
        sumWidth:1330,
        title:'MODULOS',
        titleColor:'#3b5999',
        titleSizeXL:18,
        titleSizeXS:13,
        widthAction:160,
    };

    return (
        <TablaYounet
            headCellsColumn={headCellsColumn}
            variablesObject={variablesObject}
        />
    )
}

export default Element;